
const BaseTheme = require('./base');
const ZekiTheme = require('./zeki');
const VuetifyDefaultTheme = require('./vuetify');

module.exports = {BaseTheme, ZekiTheme, VuetifyDefaultTheme};
